app.controller('leadsController', function($http, $scope, $stateParams, $location, dataService, DTColumnBuilder, pageConfig, pageHandler, $timeout, $modal, $anchorScroll, $controller, anchorSmoothScroll, $window) {

	//Include custom controller functionality
	$controller('userDefinedLeadsController', {$scope: $scope, $stateParams: $stateParams});
	
	//initialise survey specific views
	pageHandler.initViews(pageConfig, $scope);

	//initialise filters
	var filtersLoaded = pageHandler.initFilters(pageConfig, $scope);
	
	if(filtersLoaded)
	{	
		//initialise components
		pageHandler.initComponents(pageConfig, $scope);
	
		//show loading on components
		pageHandler.showLoading(pageConfig, $scope);
	
		//request data for components
		pageHandler.requestDataForComponents(pageConfig, $scope);
		
		//initialize export feature
		pageHandler.initPageExports(pageConfig, $scope);
	}

	$scope.loadLeadsComponents = function(excluded_component_key)
	{
		//console.log(excluded_component_key);
		//delete $scope[excluded_component_key];
		//$scope[componentKey]
		//console.log($scope);
		//pageHandler.initComponents(pageConfig, $scope);
	
		//show loading on components
		pageHandler.showLoading(pageConfig, $scope);
	
		//request data for components
		pageHandler.requestDataForComponents(pageConfig, $scope);
		
		//initialize export feature
		pageHandler.initPageExports(pageConfig, $scope);
	}

	$scope.showLeadsPopUp = function(rowData, component, componentKey)
	{
		if(typeof(component.config.rowclick_condition) != 'undefined')
		{
			if(typeof(rowData[component.config.rowclick_condition.status]) != 'undefined')
			{
				if(component.config.rowclick_condition.status_value.indexOf(rowData[component.config.rowclick_condition.status]) != -1)
				{
					
					var selectkey = component.config.click_key;
					var selectsurveykey = (typeof(component.survey_key) != 'undefined') ? component.survey_key : null;

					//store variables for popup
					$scope.popupData = {};
					$scope.popupData.componentKey = componentKey;
					$scope.popupData.url = 'leads/update_records';

					var post_data = {};
					post_data['selectkey'] = selectkey;
					post_data['selectvalue'] = (typeof(rowData[selectkey]) != 'undefined') ? rowData[selectkey] : null;
					post_data['selectsurveyvalue'] = (typeof(selectsurveykey) != 'undefined') ? selectsurveykey : null;
					post_data['app_state'] = $scope.appState;

					$scope.pageState= {};
					$scope.pageState.selectkey = post_data['selectkey'];
					$scope.pageState.selectvalue = post_data['selectvalue'];
					$scope.pageState.selectsurveyvalue = post_data['selectsurveyvalue'];

					$scope[componentKey].selectedRowData = {};
					$scope[componentKey].selectedRowData.details = rowData;

					$scope.lead_status_to_disable_form = {};
					if(typeof(component.status_to_disable_form) != 'undefined')
                    {
                        $scope.lead_status_to_disable_form = component.status_to_disable_form;
                    }


					var leads_popup_template = 'views/leads_popup.html';
					if(typeof($scope.static_cache_time) != 'undefined')
					{
						leads_popup_template += "?" + $scope.static_cache_time;
					}

					//open popup
					var modalInstance = $modal.open({
				           templateUrl: leads_popup_template,
				           controller: leadsPopUpInstanceCtrl,
				           scope : $scope,
				           windowClass : 'large_popup_window'
				    });
					return true;
				}
			}
		}
		return false;
	}

	$scope.checkValueEqualities = function(val1,val2)
	{
		var text = 'equal';
		if(parseFloat(val1) > parseFloat(val2))
		{
			text = 'greater';
		}
		if(parseFloat(val1) < parseFloat(val2))
		{
			text = 'lesser';
		}
		return text;
	}
	
});

function leadsPopUpInstanceCtrl($scope, $modalInstance, $timeout, dataService, $controller)
{

	var lead_status_to_disable_form = $scope.$parent.lead_status_to_disable_form;

	//init variables for popup
	var componentKey = $scope.$parent.popupData.componentKey;
	var url = $scope.$parent.popupData.url;
	$scope.formData = {};

	//request data
	var post_data = angular.copy($scope.$parent.pageState);
	post_data['app_state'] = $scope.$parent.appState;
	post_data['page_mode'] = 'read';

	//show loading
	$timeout(function(){
		$('.large_popup_window .big-loading-container').show();
		$('.large_popup_window .popup_request_content').show();
	}, 0);

	dataService.getData(url, post_data , 'POST')
		.then(function(response) {

            if(typeof(response.data.error) == 'undefined')
            {
    			//hide loading
    			$('.large_popup_window .big-loading-container').hide();

    			if(typeof(response.data) != 'undefined')
    			{
    				$scope['disable_submit_button'] = false;
					if(typeof(response.data.lead_status) != 'undefined')
					{
						if(lead_status_to_disable_form.indexOf(response.data.lead_status) != -1)
						{
							$scope['disable_submit_button'] = true;
						}
					}
    				
                    /*angular.forEach(pop_up_fields, function(key_value, key) {
                        $scope[key] = (typeof(response.data[key]) != 'undefined') ? response.data[key] : '';
                    });*/
                    $scope['leads_details'] = (typeof(response.data) != 'undefined') ? response.data : '';
    			}
            } else {
                //hide form
                $('.large_popup_window .big-loading-container').hide();
                $('.large_popup_window .popup_request_content').hide();

                //show status
                $('.large_popup_window .alert').addClass('alert-danger').html(response.message);
                $('.large_popup_window .alert').show();

                //hide update button and change cancel to OK
                $('.large_popup_window .popup_update_button').hide();
                $('.large_popup_window .popup_close_button').html('CLOSE');
            }
		}
	);

	/*$(document).on('change', '.compare', function () {
        var is_disabled = true;
        var lead_status = $.trim($("#lead_status").val());
        var lead_comments = $.trim($("#lead_status").val());
        if($scope['leads_details']['lead_status'] != lead_status)
        {
            is_disabled = false;
        }

        if(!is_disabled)
        {
            $('#submit_button').removeAttr('disabled');
			return true;
        }
        $('#submit_button').attr('disabled', true);
	});*/

	$scope.update = function()
	{
		var post_data = angular.copy($scope.$parent.pageState);
        post_data['app_state'] = $scope.$parent.appState;
        post_data['page_mode']  = 'update';
        var required_fields = {};

		var update = true;
		$('#formId input, #formId select , #formId textarea').each(
		    function(index){  
		        var input = $(this);
		        var cur_val = input.val();
		        var required = input.attr('required');
		        var key = input.attr('name');
	
		        if(required != undefined && required == 'required')
		        {
		        	if(cur_val == '')
		        	{
		        		console.log(key);
		        		update = false;
		        		required_fields[key] = $(this).attr('placeholder');
		        	}
		        }
		        post_data[key] = cur_val;
		    }
		);

		$('.large_popup_window .alert').removeClass('alert-danger alert-success alert-info').html('').hide();

		if(update === true)
		{
			//show loading
			$('.large_popup_window .alert').html('<div class="spinner"><div class="rect1"></div><div class="rect2"></div><div class="rect3"></div><div class="rect4"></div><div class="rect5"></div></div>');
			$('.large_popup_window .alert').show();

			//Add comment
			var url = $scope.$parent.popupData.url;
			dataService.getData(url, post_data , 'POST')
				.then(function(response) {

					//hide loading
					$('.large_popup_window .alert').hide();
					if(typeof(response.data) != 'undefined')
					{
						if(typeof(response.data.status) != 'undefined')
						{
							$('.large_popup_window .popup_request_content').hide();
							//$('#'+post_data['selectvalue']).remove();
							
							var componentKey = $scope.$parent.popupData.componentKey;
							var page = $scope[componentKey].instance.DataTable.page();

							$scope[componentKey].instance.DataTable.page(page).draw(false)

							

							//show status
							$('.large_popup_window .alert').addClass('alert-success').html(response.message);
							$('.large_popup_window .alert').show();

							$scope.loadLeadsComponents(componentKey);

							//hide update button and change cancel to OK
							$('.large_popup_window .popup_update_button').hide();
							$('.large_popup_window .popup_close_button').html('CLOSE');
						}
						else
						{
                            //hide form
							$('.large_popup_window .popup_request_content').hide();

							//show status
							$('.large_popup_window .alert').addClass('alert-danger').html(response.message);
                            $('.large_popup_window .alert').show();

                            //hide update button and change cancel to OK
							$('.large_popup_window .popup_update_button').hide();
							$('.large_popup_window .popup_close_button').html('CLOSE');
						}
					}
				}
			);
		}
		else
		{
			var error_text = 'Fields cannot be empty';
			var elmt_length = Object.keys(required_fields).length;
			if(elmt_length > 0)
			{
				error_text = '';
				var i = 1;
				angular.forEach(required_fields, function(value, key) {
					error_text += value;
					if(elmt_length > i)
					{
						error_text += ', ';
					}
					i++;
				});
				error_text += ' cannot be empty';
			}

			$('.large_popup_window .alert').addClass('alert-danger').html(error_text);
			$('.large_popup_window .alert').show();
		}
	}

	$scope.cancel = function() {
        $modalInstance.dismiss('cancel');
    };

}
